import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { ConfigurationPlanningService } from '../configuration-planning.service';
import { ConfigurationStaffViewPart } from './staff/staff-view.part';
import { ConfigurationTrimestersViewPart } from './trimesters/trimesters-view.part';
@Component({
	selector: 'configuration-planning-views-part',
	standalone: true,
	imports: [
		ConfigurationTrimestersViewPart,
		ConfigurationStaffViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './planning-views.part.html',
})
export class ConfigurationPlanningViewsPart implements OnInit {
	public service = inject(ConfigurationPlanningService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}